import { atom } from "recoil";
import { contentLangType } from "./type";

// export type socketStateType = string;

export const refreshOrderState = atom<NewOrderType>({
  key: "refreshOrder",
  default: {
    date: "",
    order_status: 0,
    order_category: 0,
  },
});

export type NewOrderType = {
  date: any;
  order_status: number;
  order_category: number;
  cancel_description?: string;
  pickup_name?: string;
  pickup_name_en?: string;
};

export const requestReviewState = atom<RequestReviewType | null>({
  key: "requestReview",
  default: null,
});

export type RequestReviewType = {
  order_id: string;
  order_seq: number;
  status: number | undefined;
  user_token_id: number;
  store_id: number;
  parent_store_id: number;
  store_name: string;
  product_name: string;
  product_name_en: string;
  product_name_ch: string;
  product_name_ja: string;
  product_name_th: string;
  product_quantity: number;
};

export type connectType = {
  type: boolean;
  is_first: boolean;
};

export type checkoutType = {
  date: string;
  notice_detail_id: number;
  log_id: number;
  can_purchase_more_time: boolean;
  extend_types: number[];
};
export type checkoutDetailType = contentLangType & {
  checkout_date: string | null;
  checkout_time: string | null;
  content: string;
  sound_duration_sec: number;
  sound_type: number;
  extend_types: number[];
};
export type ConciergeStateType = {
  concierge_id: number | null;
  isChat: boolean;
  date: string;
};

export const connectState = atom<connectType>({
  key: "connectState",
  default: {
    type: false,
    is_first: true,
  },
});

export const checkoutState = atom<checkoutType>({
  key: "Checkout",
  default: {
    date: "",
    notice_detail_id: -1,
    log_id: -1,
    can_purchase_more_time: false,
    extend_types: [],
  },
});

export const checkoutPayCompleteModalVisible = atom<boolean>({
  key: "checkoutPayCompleteModal",
  default: false,
});
export const conciergeState = atom<ConciergeStateType>({
  key: "conciergeState",
  default: {
    concierge_id: null,
    isChat: false,
    date: "",
  },
});
